module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","signup":"Sign up"},"hu":{"login":"Belépés","signup":"Regisztráció"}}')
  delete Component.options._Ctor
}
